import DatePickerPluginCss from '!raw-loader!react-datepicker/dist/react-datepicker.css';
import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import svgArrow from '@img/icons/background/arrow-red.svg?url';
import ButtonStyles from '@stories/Components/Global/Buttons/Button/Button.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Wrapper = styled.div `
  ${DatePickerPluginCss};

  ${ButtonStyles.Container} {
    align-self: center;
  }

  .react-datepicker {
    ${fonts.daxWide.regular};

    border-radius: 0;
    border-color: ${brand.ess.secondary.lightestGrey};
  }

  .react-datepicker__tab-loop {
    display: contents;
  }

  .react-datepicker__header {
    background-color: ${brand.global.white};
    border: 0;
    border-radius: 0;
    padding-top: 12px;
  }

  .react-datepicker__navigation {
    top: 4px;

    &::before {
      display: block;
      content: '';
      background-image: url(${svgArrow});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      width: 20px;
      height: 15px;
    }
  }

  .react-datepicker__navigation--next {
    right: 6px;
  }

  .react-datepicker__navigation--previous {
    left: 6px;

    &::before {
      transform: rotate(180deg);
    }
  }

  .react-datepicker__navigation-icon::before {
    display: none;
  }

  .react-datepicker__tab-loop__start,
  .react-datepicker__tab-loop__end {
    display: none;
  }

  .react-datepicker__day--in-range,
  .react-datepicker__day--in-range:hover,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--selected {
    background-color: ${brand.global.red} !important;
    color: ${brand.global.white} !important;
  }

  .react-datepicker__current-month {
    font-size: ${fluid(16, 18)};
    margin-bottom: ${fluid(10, 12)};
    text-transform: uppercase;
  }

  .react-datepicker__current-month,
  .react-datepicker__day {
    [data-site='ess'] & {
      color: ${brand.ess.primary};
    }

    [data-site='mep'] & {
      color: ${brand.mep.primary};
    }

    &.react-datepicker__day--disabled {
      color: ${brand.ess.secondary.midGrey};
    }
  }

  .react-datepicker__day-name {
    [data-site='ess'] & {
      color: ${brand.ess.secondary.darkGrey};
    }

    [data-site='mep'] & {
      color: ${brand.mep.secondary.darkestGrey};
    }
  }

  .react-datepicker__day-name,
  .react-datepicker__day {
    font-size: 14px;
    width: 38px;
    font-weight: 700;
  }

  .react-datepicker__day {
    ${transition('background-color, color')};

    line-height: 38px;
    margin: 0;
    border-radius: 0 !important;

    &:hover {
      background-color: ${rgba(brand.global.red, 0.5)};
    }
  }
`;
const LabelText = styled.div `
  font-size: ${fluid(16, 20)};
  line-height: ${fluid(26, 30)};
  color: var(--labelColour);
  text-decoration: uppercase;
  padding: 0 0 ${fluid(10, 12)};
  margin: 0 0 ${fluid(24, 42)};
  border-bottom: 1px solid var(--borderColour);

  [data-site='ess'] & {
    --borderColour: ${brand.ess.secondary.darkGrey};
    --labelColour: ${brand.ess.secondary.darkestGrey};

    ${fonts.daxWide.medium};
  }

  [data-site='mep'] & {
    --borderColour: ${brand.mep.secondary.darkestGrey};
    --labelColour: ${brand.mep.primary};

    ${fonts.museoSlab.medium};
  }
`;
const PickerWrapper = styled.div `
  display: grid;
  place-content: center;
`;
export default {
    Wrapper,
    LabelText,
    PickerWrapper,
};
